document.addEventListener("DOMContentLoaded", function () {
  const postList = document.querySelector(".post-list");
  const filter1 = document.getElementById("filter-1");
  const filter2 = document.getElementById("filter-2");
  const categoryLinks = document.querySelectorAll(".category-list a");

  // Verifica se os elementos existem
  if (!postList || !filter1 || !filter2) {
    console.error("Elementos necessários não encontrados na página");
    return;
  }

  let currentPage = 1;
  let postsPerPage = 5;

  // Obtém a categoria da URL caso exista
  const urlParams = new URLSearchParams(window.location.search);
  let currentCategory = urlParams.get("category") || "";

  let sortBy = "date";
  let sortOrder = "DESC";
  let allPosts = [];
  let totalPages = 0;

  // Marca a categoria ativa na lista lateral caso esteja na URL
  if (currentCategory) {
    categoryLinks.forEach((link) => {
      const href = link.getAttribute("href") || "";
      const urlParamsLink = new URLSearchParams(href.split("?")[1] || "");
      const linkSlug = urlParamsLink.get("category") || "";
      if (linkSlug === currentCategory) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });
  }

  // Carrega posts iniciais
  updateSortBy();
  loadPosts();

  // Event listeners para filtros
  filter1.addEventListener("change", () => {
    currentPage = 1;
    updateSortBy();
    loadPosts();
  });

  filter2.addEventListener("change", () => {
    currentPage = 1;
    updateSortBy();
    loadPosts();
  });

  // Filtro de categorias
  categoryLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();

      // Remove classe ativa de todos
      categoryLinks.forEach((l) => l.classList.remove("active"));

      // Adiciona classe ativa ao clicado
      link.classList.add("active");

      currentPage = 1;

      // Obtém o slug da URL do link
      const href = link.getAttribute("href") || "";
      const urlParamsLink = new URLSearchParams(href.split("?")[1] || "");
      const categorySlug = urlParamsLink.get("category") || "";

      currentCategory = categorySlug || link.textContent.trim();

      // Atualiza a URL do navegador sem recarregar a página
      const newUrl = categorySlug ? `?category=${categorySlug}` : window.location.pathname;
      window.history.pushState({ category: categorySlug }, "", newUrl);

      loadPosts();
    });
  });

  // Escuta a navegação de voltar/avançar no navegador
  window.addEventListener("popstate", () => {
    const urlParams = new URLSearchParams(window.location.search);
    currentCategory = urlParams.get("category") || "";
    currentPage = 1;

    categoryLinks.forEach((link) => {
      const href = link.getAttribute("href") || "";
      const urlParamsLink = new URLSearchParams(href.split("?")[1] || "");
      const linkSlug = urlParamsLink.get("category") || "";
      if (linkSlug === currentCategory) {
        link.classList.add("active");
      } else {
        link.classList.remove("active");
      }
    });

    loadPosts();
  });

  function updateSortBy() {
    const filter1Value = filter1.value;
    const filter2Value = filter2.value;

    // Filter 1 define ordenação por data
    if (filter1Value === "recent") {
      sortBy = "date";
      sortOrder = "DESC";
    } else if (filter1Value === "old") {
      sortBy = "date";
      sortOrder = "ASC";
    }

    // Filter 2 é ignorado por enquanto (views não implementado no backend)
    // No futuro: if (filter2Value === "most_view") { ... }
  }

  function loadPosts() {
    // Verifica se blogAjax está disponível
    if (typeof blogAjax === "undefined") {
      console.error("blogAjax não está disponível");
      return;
    }

    const formData = new FormData();
    formData.append("action", "load_blog_posts");
    formData.append("nonce", blogAjax.nonce);
    formData.append("category", currentCategory);
    formData.append("sortby", sortBy);
    formData.append("sort_order", sortOrder);
    formData.append("page", currentPage);
    formData.append("per_page", postsPerPage);

    fetch(blogAjax.ajaxurl, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          console.log("Página:", currentPage, "Total de páginas:", data.data.pages, "Posts recebidos:", data.data.posts.length);
          renderPosts(data.data.posts);
          totalPages = data.data.pages;
          renderPagination();
          allPosts = data.data.posts;
        } else {
          console.error("Erro na resposta AJAX:", data);
          renderPosts([]);
        }
      })
      .catch((error) => {
        console.error("Erro ao carregar posts:", error);
        renderPosts([]);
      });
  }

  function renderPosts(posts) {
    // Faz fade out
    postList.style.transition = "opacity 0.3s ease";
    postList.style.opacity = "0";

    setTimeout(() => {
      postList.innerHTML = "";

      if (!posts || posts.length === 0) {
        postList.innerHTML = '<div class="col-12"><p class="text-center">Nenhum post encontrado.</p></div>';
        postList.style.opacity = "1";
        return;
      }

      posts.forEach((post) => {
        const col = document.createElement("div");
        col.className = "col-md-6 col-12";

        const imgSrc = post.image && post.image.trim() !== "" ? post.image : "https://placehold.net/400x400.png";
        const title = post.title || "Sem título";
        const date = post.date || "00.00.0000";
        const link = post.link || "#";

        col.innerHTML = `
          <a href="${link}" class="card-post anfluid">
            <img src="${imgSrc}" alt="${title}" class="img-fluid">
            <div class="card-body">
              <p class="date">${date}</p>
              <p class="title">${title}</p>
            </div>
            <div class="card-footer">
              <p class="link">Saiba mais</p>
            </div>
          </a>
        `;
        postList.appendChild(col);
      });

      // Faz fade in
      postList.style.opacity = "1";
    }, 150);
  }

  function renderPagination() {
    // Remove paginação antiga
    const oldPagination = document.querySelector(".pagination-blog");
    if (oldPagination) {
      oldPagination.remove();
    }

    console.log("Renderizando paginação. Total de páginas:", totalPages, "Página atual:", currentPage);

    if (totalPages <= 1) {
      console.log("Apenas 1 página ou menos, não renderiza paginação");
      return;
    }

    // Cria container de paginação
    const paginationContainer = document.createElement("div");
    paginationContainer.className = "pagination-blog";

    // Botão anterior
    const prevBtn = document.createElement("button");
    prevBtn.className = "pagination-btn prev-btn";
    prevBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5001 10L2.91675 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.33333 4.16683L2.5 10.0002L8.33333 15.8335" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => {
      if (currentPage > 1) {
        currentPage--;
        loadPosts();
        scrollToPostList();
      }
    });
    paginationContainer.appendChild(prevBtn);

    // Números de página
    let pagesToRender = [];
    const isMobile = window.innerWidth <= 767;

    if (isMobile) {
      if (totalPages <= 3) {
        for (let i = 1; i <= totalPages; i++) {
          pagesToRender.push(i);
        }
      } else {
        if (currentPage <= 2) {
          pagesToRender = [1, 2, '...', totalPages];
        } else if (currentPage >= totalPages - 1) {
          pagesToRender = [1, '...', totalPages - 1, totalPages];
        } else {
          pagesToRender = [1, '...', currentPage, '...', totalPages];
        }
      }
    } else {
      if (totalPages <= 5) {
        for (let i = 1; i <= totalPages; i++) {
          pagesToRender.push(i);
        }
      } else {
        if (currentPage <= 3) {
          pagesToRender = [1, 2, 3, 4, '...', totalPages];
        } else if (currentPage >= totalPages - 2) {
          pagesToRender = [1, '...', totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
          pagesToRender = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
        }
      }
    }

    pagesToRender.forEach(i => {
      if (i === '...') {
        const dots = document.createElement("span");
        dots.className = "pagination-dots";
        dots.textContent = "...";
        dots.style.display = "flex";
        dots.style.alignItems = "flex-end";
        dots.style.justifyContent = "center";
        dots.style.padding = "0 5px";
        dots.style.color = "#a51d20";
        dots.style.fontWeight = "bold";
        paginationContainer.appendChild(dots);
      } else {
        const pageBtn = document.createElement("button");
        pageBtn.className = "pagination-btn page-btn";
        pageBtn.textContent = String(i).padStart(2, "0");
        pageBtn.dataset.page = i;

        if (i === currentPage) {
          pageBtn.classList.add("active");
        }

        pageBtn.addEventListener("click", () => {
          console.log("Clicou na página:", i);
          currentPage = i;
          console.log("currentPage agora é:", currentPage);
          loadPosts();
          scrollToPostList();
        });

        paginationContainer.appendChild(pageBtn);
      }
    });

    // Botão próximo
    const nextBtn = document.createElement("button");
    nextBtn.className = "pagination-btn next-btn";
    nextBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2.49992 10H17.0833" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.6667 15.8332L17.5 9.99984L11.6667 4.1665" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => {
      if (currentPage < totalPages) {
        currentPage++;
        loadPosts();
        scrollToPostList();
      }
    });
    paginationContainer.appendChild(nextBtn);

    // Insere paginação após a lista de posts
    postList.parentElement.appendChild(paginationContainer);
    console.log("Paginação criada com " + totalPages + " páginas");
  }

  function scrollToPostList() {
    const postListTop = postList.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({
      top: postListTop,
      behavior: "smooth",
    });
  }
});
